import { MemedExamCard } from './MemedExamCard';

interface Exam {
  id: string;
  patientName: string;
  date: string;
  exams: string[];
  memedStatus: 'PENDING' | 'SYNCED' | 'FAILED' | 'SIGNED' | 'CANCELLED' | 'IDLE';
  memedId?: string;
  pdfUrl?: string;
}

interface MemedExamListProps {
  exams: Exam[];
  isLoading?: boolean;
  onViewPdf?: (id: string) => void;
  onResend?: (id: string) => void;
  onSync?: (id: string) => void;
  syncingIds?: Set<string>;
  resendingIds?: Set<string>;
}

export function MemedExamList({
  exams,
  isLoading,
  onViewPdf,
  onResend,
  onSync,
  syncingIds = new Set(),
  resendingIds = new Set(),
}: MemedExamListProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {[1, 2, 3].map((i) => (
          <div key={i} className="rounded-xl bg-white border border-neutral-200 shadow-sm p-5 animate-pulse">
            <div className="h-4 bg-gray-200 rounded w-1/3 mb-4" />
            <div className="h-6 bg-gray-200 rounded w-2/3 mb-4" />
            <div className="space-y-2">
              <div className="h-3 bg-gray-200 rounded w-1/2" />
              <div className="h-3 bg-gray-200 rounded w-1/2" />
              <div className="h-3 bg-gray-200 rounded w-1/2" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {exams.map((exam) => (
        <MemedExamCard
          key={exam.id}
          exam={exam}
          onViewPdf={() => onViewPdf?.(exam.id)}
          onResend={() => onResend?.(exam.id)}
          onSync={() => onSync?.(exam.id)}
          isSyncing={syncingIds.has(exam.id)}
          isResending={resendingIds.has(exam.id)}
        />
      ))}
    </div>
  );
}